module.exports = "pegasus/assets/circle-snapchat.png";